<template>
  <div class="container">
    <div>
      <el-tabs
        v-model="editableTabsValue"
        type="border-card"
        @tab-click="handleClick"
      >
        <el-tab-pane label="异常工单列表" name="abnormal_work"></el-tab-pane>
        <el-tab-pane label="无数据工单列表" name="no_data_work"></el-tab-pane>
        <el-tab-pane label="拒收工单列表" name="refuse_work"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="editableTabsValue === 'no_data_work'">
      <no-data-work-list></no-data-work-list>
    </div>
    <div v-if="editableTabsValue === 'abnormal_work'">
      <abnormal-work-list></abnormal-work-list>
    </div>
    <div v-if="editableTabsValue === 'refuse_work'">
      <refuse-work-list></refuse-work-list>
    </div>
  </div>
</template>

<script>
import AbnormalWorkList from "./AbnormalWorkList.vue";
import NoDataWorkList from "./NoDataWorkList.vue";
import RefuseWorkList from "./RefuseWorkList.vue";

export default {
  components: { AbnormalWorkList, NoDataWorkList, RefuseWorkList },
  data() {
    return {
      editableTabsValue: "abnormal_work",
    };
  },
  mounted() {
    const tab = { name: "abnormal_work" };
    this.handleClick(tab);
  },
  methods: {
    handleClick(tab) {
      this.editableTabsValue = tab.name;
    },
  },
};
</script>

<style scoped>
.el-tabs__content {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/Work.vue